module.exports = __webpack_public_path__ + "assets/img/newsIcon3.45a67d7d.png";